import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import { Container, Title } from 'common/components/Layout/Layout';
import styles from './PresentationsListView.module.scss';
import messages from './PresentationsListView.intl';
import ReturnToInvestors from '../../common/components/ReturnToInvestors/ReturnToInvestors';
import ContentStore from '../../stores/Content.store';
import SideMenu from './Components/SideMenu/SideMenu';
import PresentationListItem from './Components/PresentationListItem/PresentationListItem';

@injectIntl
@withRouter
@observer
export default class PresentationsListView extends Component {
  render() {
    if (!ContentStore.isLoaded) {
      return null;
    }

    const presentations = ContentStore.content.presentations.value;

    return (
      <div className={styles.PresentationsView}>
        <Container>
          <Title title={this.props.intl.formatMessage(messages.sectionTitle)} />
        </Container>
        <Container>
          <ReturnToInvestors />
          <div className={`${styles.PresentationsList}`}>
            <Container>
              {presentations.map((presentation, index) => {
                return (
                  <PresentationListItem
                    key={presentation.system.id}
                    presentation={presentation}
                  />
                );
              })}
            </Container>
          </div>
          <div className={`${styles.SideMenuWrapper}`}>
            <SideMenu />
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Presentations/PresentationsListView.js